<template>
  <div>
    <Title :pages="[{ icon: 'book', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <ModalAsiento
        v-if="create_access"
        :button_name="$t('Crear') + ' Asiento'"
        modal_title="Asiento Manual"
        :formBtn="formBtn"
        :dialog="dialog"
        :service="service"
        :emitters="emitters"
        @updateDialog="updateDialog"
        @loadList="filterList"
        :item="mainItem"
        @updateItem="
          (newItem) => {
            mainItem = newItem;
          }
        "
      />

      <!-- Filtros -->
      <v-card>
        <div class="row mb-2 mt-0">
          <div class="col-md-12" v-if="list_access">
            <div class="col-md-12 elevation-0" style="background: white">
              <div class="row pt-5">
                <div class="col-md-3 pt-0">
                  <v-combobox v-model="emitter_selected" autocomplete="off" item-text="name" item-value="id" :items="emitters" label="Emisor" class="pt-0 mt-0" return-object></v-combobox>
                </div>
                <div class="col-md-2 pt-0">
                  <DatePickerEsp
                    class="date-filter"
                    label="Desde"
                    name="date_from"
                    :date="date_from"
                    @setDate="
                      (date) => {
                        date_from = date;
                      }
                    "
                  />
                </div>
                <div class="col-md-2 pt-0">
                  <DatePickerEsp
                    class="date-filter"
                    label="Hasta"
                    name="date_to"
                    :date="date_to"
                    @setDate="
                      (date) => {
                        date_to = date;
                      }
                    "
                  />
                </div>
                <div class="col-md-3 pt-0">
                  <v-combobox v-model="origin_selected" autocomplete="off" item-text="name" item-value="id" :items="origins" label="Origen" class="pt-0 mt-0" clearable return-object></v-combobox>
                </div>
                <div class="col-md-2 pt-0">
                  <v-combobox v-model="state_selected" autocomplete="off" item-text="name" item-value="id" :items="states" label="Estado" class="pt-0 mt-0" clearable return-object></v-combobox>
                </div>
              </div>
              <div class="row">
                <div class="col-md-2 pt-0">
                  <v-text-field v-model="id_filter" type="number" label="ID" class="pt-0 mt-0" clearable @keyup.enter="filterList"></v-text-field>
                </div>
                <div class="col-md-2 pt-0">
                  <v-text-field v-model="number_filter" type="number" label="Número" class="pt-0 mt-0" clearable @keyup.enter="filterList"></v-text-field>
                </div>
                <div class="col pt-0" style="display: flex; justify-content: end">
                  <v-btn color="blue-grey" class="mr-2" dark :loading="dialog_export" @click="exportFile()"> Exportar <font-awesome-icon class="ml-2" icon="download" /></v-btn>

                  <v-btn color="info" @click="filterList">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <v-card v-if="list_access">
        <v-card-title>
          <span class="text-uppercase">{{ page_title }}</span>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="list"
          :search="search"
          :loading="loading"
          loading-text="Cargando..."
          :options="{ itemsPerPage: 15 }"
          @pagination="updatePagination"
          :footer-props="{ itemsPerPageOptions: [5, 10, 15, 50, -1] }"
        >
          <template v-slot:item="props">
            <tr>
              <td>{{ props.item.id }}</td>
              <td>{{ props.item.date_esp }}</td>
              <td>{{ props.item.number || "-" }}</td>
              <td>{{ props.item.description }}</td>
              <td>
                <v-chip x-small :color="props.item.state === 'confirmado' ? 'green' : props.item.state === 'anulado' ? 'red' : 'orange'" dark>
                  {{ props.item.state }}
                </v-chip>
              </td>
              <td>{{ props.item.origin_type_label }}</td>
              <td class="text-right">{{ formatUtils.formatPrice(props.item.total_debe) }}</td>
              <td class="text-center px-0">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="update_access && props.item.state === 'borrador' && props.item.origin_type === 'manual'" v-on="on" small color="blue" class="mr-2" @click="editItem(props.item)"
                      >edit</v-icon
                    >
                  </template>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="blue" class="mr-1" @click="viewItem(props.item)">remove_red_eye</v-icon>
                  </template>
                  <span>Ver</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="delete_access && props.item.state === 'borrador' && props.item.origin_type === 'manual'" v-on="on" small color="red" class="mr-2" @click="deleteItem(props.item)"
                      >delete</v-icon
                    >
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              {{ "Busqueda sin resultados - " + search }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card>

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteItemConfirm" />
    </v-container>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";
import { emmiterService } from "@/libs/ws/emmiterService";
import { formatUtils } from "@/libs/utils/formatUtils";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";
import Title from "@/components/Title.vue";
import DialogDelete from "@/components/DialogDelete.vue";
import DatePickerEsp from "@/components/DatePickerEsp.vue";
import ModalAsiento from "./Modal.vue";
import AsientoOrigins from "@/constants/asientoOrigins";

export default {
  components: { Title, ModalAsiento, DialogDelete, DatePickerEsp },
  mixins: [GenericMixin, RolMixin, ExportMixin],
  data() {
    return {
      parent: this,
      service: generalService,
      formatUtils: formatUtils,
      page_title: "Libro Diario",
      emitters: [],
      emitter_selected: null,
      date_from: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10),
      date_to: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().slice(0, 10),
      id_filter: null,
      number_filter: null,
      state_selected: null,
      origin_selected: null,
      origins: AsientoOrigins.originItems(),
      states: [
        { id: "borrador", name: "Borrador" },
        { id: "confirmado", name: "Confirmado" },
        { id: "anulado", name: "Anulado" },
      ],
      mainItem: {
        id: "",
        date: new Date().toISOString().slice(0, 10),
        description: "",
        emitter: null,
        lineas: [],
      },
      defaultItem: null,
      headers: [
        { text: "ID", align: "left", sortable: true, value: "id" },
        { text: "Fecha", align: "left", sortable: true, value: "date" },
        { text: "Número", align: "left", sortable: true, value: "number" },
        { text: "Descripción", align: "left", sortable: true, value: "description" },
        { text: "Estado", align: "left", sortable: true, value: "state" },
        { text: "Origen", align: "left", sortable: true, value: "origin_type_label" },
        { text: "Importe", align: "right", sortable: true, value: "total_debe" },
        { text: "Accion", value: "", align: "center" },
      ],
      list: [],
      dialog_delete: false,
    };
  },
  mounted() {
    this.defaultItem = JSON.parse(JSON.stringify(this.mainItem));
    this.service.setSection(Constant.SECTION_ASIENTOS);
    this.loadEmitters();
  },
  methods: {
    loadEmitters() {
      emmiterService.filter({ enabled: true }).then((response) => {
        this.emitters = response.result || [];
        if (this.emitters.length > 0) {
          this.emitter_selected = this.emitters[0];
          this.filterList();
        }
      });
    },
    getFilterParams() {
      return {
        emitter: this.emitter_selected != null ? this.emitter_selected.id : null,
        date_from: this.date_from || null,
        date_to: this.date_to || null,
        state: this.state_selected != null ? this.state_selected.id : null,
        origin_type: this.origin_selected != null ? this.origin_selected.id : null,
        id: this.id_filter || null,
        number: this.number_filter || null,
      };
    },
    filterList() {
      this.service.setSection(Constant.SECTION_ASIENTOS);
      this.loadList(this.service, this.getFilterParams());
    },
    exportFile() {
      const param = this.getFilterParams();
      param.export = true;
      this.exportExcel(Constant.SECTION_ASIENTOS + "/list", param, "Libro-Diario.xlsx");
    },
    deleteItemConfirm() {
      this.delete(this.service);
      this.dialog_delete = false;
      this.filterList();
    },
  },
};
</script>

<style scoped>
.date-filter >>> .v-text-field {
  padding-top: 0;
  margin-top: 0;
}
</style>
